import { render } from "./RiProdoffering08.vue?vue&type=template&id=ee19bc9c"
import script from "./RiProdoffering08.vue?vue&type=script&lang=js"
export * from "./RiProdoffering08.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiProdoffering08.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ee19bc9c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ee19bc9c', __exports__)) {
    api.reload('ee19bc9c', __exports__)
  }
  
  module.hot.accept("./RiProdoffering08.vue?vue&type=template&id=ee19bc9c", () => {
    api.rerender('ee19bc9c', render)
  })

}


export default __exports__